<nav
  class="navbar navbar-expand-lg navbar-dark bg-dark justify-content-between"
>
  <!-- <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button> -->

  <!-- <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse header-custom"> -->
  <div
    [ngbCollapse]="isMenuCollapsed"
    class="collapse navbar-collapse header-custom"
  >
    <!-- <a class="navbar-brand" [routerLink]="'.'" style="padding-left: 20px;">SFERA</a> -->
    <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
      <li class="nav-item active header-button">
        <a
          class="nav-link header-white"
          [routerLink]="'/crm/agenda/main'"
          (click)="isMenuCollapsed = true"
          >{{ "Agenda" | uppercase }}</a
        >
      </li>
      <li class="nav-item active header-button">
        <a
          class="nav-link header-white"
          [routerLink]="'/crm/properties/main'"
          (click)="isMenuCollapsed = true"
          >{{ "Schedario" | uppercase }}</a
        >
      </li>
      <li class="nav-item active header-button">
        <a
          class="nav-link header-white"
          [routerLink]="'/crm/requests/main'"
          (click)="isMenuCollapsed = true"
          >{{ "Richieste" | uppercase }}</a
        >
      </li>
      <li class="nav-item active header-button">
        <a
          class="nav-link header-white"
          [routerLink]="'/crm/agents/main'"
          (click)="isMenuCollapsed = true"
          >{{
            "Mondo
          Agenti" | uppercase
          }}</a
        >
      </li>
      <li
        class="nav-item active header-button"
        *ngIf="checkRole(adminRole) || checkRole(ownerRole)"
      >
        <a
          class="nav-link header-white"
          [routerLink]="'reports/main'"
          (click)="isMenuCollapsed = true"
          >{{ "Report" | uppercase }}</a
        >
      </li>
      <li class="nav-item active header-button">
        <a
          class="nav-link header-white"
          [routerLink]="'/crm/applications/main'"
          (click)="isMenuCollapsed = true"
          >{{ "Pratiche" | uppercase }}</a
        >
      </li>
      <li class="nav-item dropdown active header-button" ngbDropdown>
        <a
          class="nav-link dropdown-toggle header-white"
          id="header-settings-dropdown"
          ngbDropdownToggle
          >{{ "Impostazioni" | uppercase }}</a
        >
        <div
          class="dropdown-menu"
          aria-labelledby="header-settings-dropdown"
          ngbDropdownMenu
        >
          <a class="dropdown-item" [routerLink]="'/crm/settings/googleoauth'"
            >Integrazioni</a
          >
          <a
            *ngIf="checkRole(adminRole)"
            class="dropdown-item"
            [routerLink]="'/crm/settings/utenti'"
            >Gestione Utenti</a
          >
          <a
            *ngIf="checkRole(adminRole)"
            class="dropdown-item"
            [routerLink]="'/crm/settings/agenzie'"
            >Gestione Agenzie</a
          >
          <a
            *ngIf="checkRole(adminRole)"
            class="dropdown-item"
            [routerLink]="'/crm/settings/zone'"
            >Gestione Zone</a
          >
          <a
            *ngIf="checkRole(adminRole)"
            class="dropdown-item"
            [routerLink]="'/crm/settings/eventi'"
            >Gestione Eventi
          </a>
        </div>
      </li>
      <li class="nav-item active header-button">
        <a href="" class="nav-link header-white" (click)="onLogout()">{{
          "Logout" | uppercase
        }}</a>
      </li>
      <li class="nav-item active header-button">
        <a
          href="//immobilieffegi.it"
          target="_blank"
          class="nav-link header-white"
          >{{ "sito" | uppercase }}</a
        >
      </li>
    </ul>
  </div>
  <div>
    <ng-container *ngIf="notifications$ | async as result">
      <ul
        class="navbar-nav flex-row ml-md-auto d-none d-md-flex align-items-center mr-1"
      >
        <li
          class="nav-item active header-button"
          style="cursor: pointer"
          (click)="notificationPanel.show($event)"
        >
          <mat-icon
            *ngIf="result.length > 0"
            class="white-icon"
            [matBadge]="result.length"
            svgIcon="bell"
            aria-hidden="false"
            aria-label="notification"
          ></mat-icon>
          <mat-icon
            *ngIf="result.length == 0"
            class="white-icon"
            svgIcon="bell"
            aria-hidden="false"
            aria-label="notification"
          ></mat-icon>
        </li>
      </ul>
    </ng-container>
  </div>
  <div>
    <ul
      class="navbar-nav flex-row ml-md-auto d-none d-md-flex align-items-center mr-4"
    >
      <li
        class="nav-item active header-button"
        style="cursor: pointer"
        [routerLink]="'/crm/messages/main'"
      >
        <mat-icon
          *ngIf="messagesCount > 0"
          class="white-icon"
          [matBadge]="messagesCount"
          svgIcon="message"
          aria-hidden="false"
          aria-label="message"
        ></mat-icon>
        <mat-icon
          *ngIf="messagesCount == 0"
          class="white-icon"
          svgIcon="message"
          aria-hidden="false"
          aria-label="message"
        ></mat-icon>
      </li>
    </ul>
  </div>
  <p-overlayPanel
    #notificationPanel
    class="m-0 p-0"
    styleClass="noPaddingOverlay"
  >
    <ng-template pTemplate>
      <mat-list #agenzieList [multiple]="false">
        <mat-list-item
          *ngFor="let n of notifications$ | async; last as last"
          (click)="setNotificationRead(n, notificationPanel)"
          style="cursor: pointer; margin-top: 10px"
        >
          <div mat-line>
            <b>{{ getNotificationTitle(n) }}</b>
          </div>
          <div
            mat-line
            class="wrap"
            style="
              word-wrap: break-word;
              min-width: 200px;
              max-width: 300px;
              white-space: break-spaces;
              margin-bottom: 10px;
            "
          >
            {{ n.notification.body }}
          </div>
          <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
        </mat-list-item>
        <ng-container *ngIf="notifications$ | async as result">
          <mat-list-item
            *ngIf="(notifications$ | async) != null && result.length < 1"
          >
            Nessuna notifica presente.
          </mat-list-item>
        </ng-container>
      </mat-list>
    </ng-template>
  </p-overlayPanel>

  <div class="header-right">
    <div class="">
      {{ user?.firstname | titlecase }} {{ user?.lastname | titlecase }}
    </div>
    <div class="" *ngIf="checkRole(adminRole)">
      Agenzia {{ agenzia?.nome }} (<a
        style="cursor: pointer; text-decoration: underline"
        (click)="op.show($event)"
        >cambia</a
      >)
    </div>
    <div class="" *ngIf="!checkRole(adminRole)">
      Agenzia {{ agenzia?.nome }}
    </div>
    <div class="">{{ user?.username | titlecase }}</div>
  </div>
  <p-overlayPanel #op class="m-0 p-0">
    <ng-template pTemplate>
      <mat-selection-list #agenzieList [multiple]="false">
        <mat-list-option
          *ngFor="let agenzia of agenzie"
          (click)="setAgenzia(agenzia, op)"
        >
          {{ agenzia.nome }}
        </mat-list-option>
      </mat-selection-list>
    </ng-template>
  </p-overlayPanel>
</nav>
